import { createUseStyles } from 'react-jss';

interface Props {
  getCalendarBackgroundColor: any;
  getCalendarDateColor: any;
  getCalendarForegroundColor: any;
};

const useStyles = createUseStyles((theme: any) => ({
  eventsWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    width: 'calc(100% - 1px)',
    //minWidth: '240px',
    height: 'calc(100% - 1px)',
    minHeight: '100px',
    gap: '4px',
    backgroundColor: (props: Props) => props.getCalendarBackgroundColor,
    borderRight: `1px solid ${theme.colors.grey[335]}`,
    borderBottom: `1px solid ${theme.colors.grey[335]}`,
    '&:nth-child(7n)': {
      borderRight: 'none',
      width: '100%',
    },
    '&:nth-last-child(-n+7)': {
      borderBottom: 'none',
      height: '100%',
    },
    '& .fontGray': {
      color: '#bcbcbc',
    },
    '& .fontDarkGray': {
      color: theme.colors.grey[550],
      fontWeight: 'normal',
    },
  },
  date: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    fontSize: '14px',
    marginTop: '5px',
    fontWeight: 'normal',
    position: 'relative',
    '& > span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '28px',
      height: '28px',
      borderRadius: '100%',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: (props: Props) => props.getCalendarDateColor,
      },
    },
  },
  today: {
    '& > span': {
      color: theme.colors.primaryBlue[500],
      backgroundColor: theme.colors.grey[250],
      fontWeight: '800',
      '&:hover': {
        backgroundColor: `${theme.colors.grey[250]} !important`,
      },
    },
  },
  events: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    gap: '4px',
    padding: '0px 0px 8px 0px',
    height: 'calc(100% - 8px)',
    maxHeight: 'calc(100% - 8px)',
    overflow: 'hidden',
  },
  moreEvents: {
    backgroundColor: (props: Props) => props.getCalendarForegroundColor,
    borderRadius: '12px',
    width: 'calc(100% - 24px)',
    padding: '0 8px',
    height: '30px',
    minHeight: '30px',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    position: 'relative',
    color: theme.colors.black,
    transition: 'background-color 0.25s',
    cursor: 'pointer',
    '& > svg': {
      display: 'block',
      width: '16px',
      height: '16px',
    },
    '&:hover': {
      backgroundColor: theme.colors.primaryBlue[50],
    },
  },
  name: {
    maxWidth: '100%',
    fontSize: '11px',
    lineHeight: '13px',
    textAlign: 'center',
    wordBreak: 'break-all',
    margin: 'auto 0',
    fontWeight: '600',
    [theme.breakpoints.down('sm')]: {
      fontSize: '9px',
    },
  },
}));

export default useStyles;